import React from "react";

export default function IonAsiaReports() {
  return (
    <div>
      <h2 style={{ color: "#0b2545" }}>I-OnAsia Reports</h2>
      <p style={{ color: "#6b7280" }}>
        Due diligence and background check reports prepared by I-OnAsia will appear here.
      </p>
      <div className="card">
        <p style={{ color: "#6b7280", margin: 0 }}>
          No reports available yet. This section will connect to the reports API once ready.
        </p>
      </div>
    </div>
  );
}
